module.exports = __webpack_public_path__ + "img/trash_icon_on_image.f346e556.svg";